import { SIE4_REPORT_URL, STANDARD_REPORT_URL } from '../../../../const/routes';
import { getDateAtStartOfGivenDate } from '../../../../utils/dates-utils';
import {
  CAMPAIGN_FIELD,
  CUSTOMER_FIELD,
  DATE_FIELD,
  DATE_FROM_FIELD,
  DATE_TO_FIELD,
  DEPOSIT_FIELD,
  EMPLOYEE_FIELD,
  FIRST_DAY_OF_CURRENT_MONTH,
  FREE_TEXT_FIELD,
  GIFT_CARD_FIELD,
  INCLUDE_INVOICES_FIELD,
  LAST_DAY_OF_CURRENT_MONTH,
  NAME_FIELD,
  PAYMENT_BY_GIFT_CARD_FIELD,
  PERSONAL_NR_FIELD,
  PRODUCT_FIELD, PRODUCT_KATEGORI_FIELD,
  PURCHASE_REFILL_GIFTS_CARDS_FIELD,
  SIX_AM,
  TIME_FROM_FIELD,
  TIME_TO_FIELD,
  TIME_UNIT_FIELD,
  TODAY_AS_DATE,
  WITHDRAWAL_FIELD,
} from './StandardReportUtils';
import {
  NUMBER_OF_SOLD_GOODS,
  SALES_VAT,
  RETURNS_VAT,
  NUMBER_OF_DISCOUNTS,
  SUM
} from '../../../common/charts/chartDataConfig';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { DAY } from '../../../../utils/dates-const';

export const EMPLOYEE_TIME_WORKED = {
  urlPath: `${STANDARD_REPORT_URL}/employee-time-worked`,
  reportName: 'EmployeeTimeWorked',
  reportTitle: <FormattedMessage
    id="report.title.EmployeeTimeWorked"
    defaultMessage="Employee Time Worked"
  />,
  isSieEnabled: false,
  serverName: 'EmployeeTimeWorked',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: TODAY_AS_DATE },
      { ...DATE_TO_FIELD, initialValue: TODAY_AS_DATE },
    ],
  
};

export const PAYOUT_PER_PRODUCT = {
  urlPath: `${STANDARD_REPORT_URL}/payout-per-product`,
  reportName: 'PayoutPerProduct',
  reportTitle: <FormattedMessage
    id="report.title.PayoutPerProduct"
    defaultMessage="Payout per product"
  />,
  isSieEnabled: false,
  serverName: 'PayoutPerProduct',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const PAYOUT_PER_CATEGORY = {
  urlPath: `${STANDARD_REPORT_URL}/payout-per-category`,
  reportName: 'PayoutPerCategory',
  reportTitle: <FormattedMessage
    id="report.title.PayoutPerCategory"
    defaultMessage="Payout per category"
  />,
  isSieEnabled: false,
  serverName: 'PayoutPerCategory',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const PAYMENTS_PER_DAY = {
  urlPath: `${STANDARD_REPORT_URL}/payments-per-day`,
  reportName: 'PaymentsPerDay',
  reportTitle: <FormattedMessage
    id="report.title.PaymentsPerDay"
    defaultMessage="Payments per day"
  />,
  isSieEnabled: false,
  serverName: 'PaymentsPerDay',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const PAYMENTS_PER_DAY_AND_EMPLOYEE = {
  urlPath: `${STANDARD_REPORT_URL}/payments-per-day-and-employee`,
  reportName: 'PaymentsPerDayAndEmployee',
  reportTitle: <FormattedMessage
    id="report.title.PaymentsPerDayAndEmployee"
    defaultMessage="Payments per day and employee"
  />,
  isSieEnabled: false,
  serverName: 'PaymentsPerDayAndEmployee',
  fields:
    [
      EMPLOYEE_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const PAYMENTS_TOTAL = {
  urlPath: `${STANDARD_REPORT_URL}/payments-total`,
  reportName: 'PaymentsTotal',
  reportTitle: <FormattedMessage
    id="report.title.PaymentsTotal"
    defaultMessage="Payments total"
  />,
  isSieEnabled: false,
  serverName: 'PaymentsTotal',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const CASH_GUARD_TRANSACTION_LOG = {
  urlPath: `${STANDARD_REPORT_URL}/cash-guard-transaction-log`,
  reportName: 'CashGuardTransactionLog',
  reportTitle: <FormattedMessage
    id="report.title.CashGuardTransactionLog"
    defaultMessage="CashGuard transaction log"
  />,
  isSieEnabled: false,
  serverName: 'CashGuardTransactionLog',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FIELD, initialValue: TODAY_AS_DATE },
    ],
};

export const EHK_SALES_OVERVIEW = {
  urlPath: `${STANDARD_REPORT_URL}/ehk-sales-overview`,
  reportName: 'EHK_SalesOverview',
  reportTitle: <FormattedMessage
    id="report.title.averageSale"
    defaultMessage="Average sales"
  />,
  isSieEnabled: false,
  serverName: 'AverageSales',
  fields:
    [
      { ...TIME_UNIT_FIELD, initialValue: DAY.value },
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...DATE_TO_FIELD, initialValue: (getDateAtStartOfGivenDate(LAST_DAY_OF_CURRENT_MONTH)) },
    ],
};

export const SALES_AND_PAYMENTS_PER_CATEGORY = {
  urlPath: `${STANDARD_REPORT_URL}/sales-and-payments-per-category`,
  reportName: 'SalesAndPaymentsPerCategory',
  reportTitle: <FormattedMessage
    id="report.title.SalesAndPaymentsPerCategory"
    defaultMessage="Sales and payments per category"
  />,
  isSieEnabled: false,
  serverName: 'SalesAndPaymentsPerCategory',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
  charts:
    [
      { ...NUMBER_OF_SOLD_GOODS, labelFields: ['Kategori'] },
      {...SALES_VAT, labelFields: ['Kategori']},
      {...RETURNS_VAT, labelFields: ['Kategori']},
    ],
};

export const SALES_PER_DATE = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-date`,
  reportName: 'SalesPerDate',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerDate"
    defaultMessage="Sales per day"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerDay',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
    ],
  charts:
    [
      { ...NUMBER_OF_SOLD_GOODS, labelFields: ['Datum'], time: true },
      { ...SALES_VAT, labelFields: ['Datum'], time: true },
      { ...RETURNS_VAT, labelFields: ['Datum'], time: true },
    ],
};

export const SALES_PER_CAMPAIGN = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-campaign`,
  reportName: 'SalesPerCampaign',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerCampaign"
    defaultMessage="Sales per campaign"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerCampaign',
  fields:
    [
      CAMPAIGN_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
    ],
};

export const SALES_PER_CATEGORY = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-category`,
  reportName: 'SalesPerCategory',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerCategory"
    defaultMessage="Sales per category"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerCategory',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
  charts:
    [
      { ...NUMBER_OF_SOLD_GOODS, labelFields: ['Kategori'] },
      {...SALES_VAT, labelFields: ['Kategori']},
      {...RETURNS_VAT, labelFields: ['Kategori']},
    ],
};

export const SALES_PER_CATEGORY_AND_EMPLOYEE = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-category-and-employee`,
  reportName: 'SalesPerCategoryAndEmployee',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerCategoryAndEmployee"
    defaultMessage="Sales per category and employee"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerCategoryAndEmployee',
  fields:
    [
      EMPLOYEE_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
  charts: [
    { ...NUMBER_OF_SOLD_GOODS, labelFields: ['Kategori', 'Anställd'] },
    {...SALES_VAT, labelFields: ['Kategori','Anställd']},
    {...RETURNS_VAT, labelFields: ['Kategori','Anställd']},
  ],
};

export const SALES_PER_CATEGORY_AND_CUSTOMER = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-category-and-customer`,
  reportName: 'SalesPerCategoryAndCustomer',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerCategoryAndCustomer"
    defaultMessage="Sales per category and customer"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerCategoryAndCustomer',
  fields:
    [
      CUSTOMER_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const SALES_PER_SUPPLIER = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-supplier`,
  reportName: 'SalesPerSupplier',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerSupplier"
    defaultMessage="Sales per supplier"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerSupplier',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
  charts:
    [
      { ...NUMBER_OF_SOLD_GOODS, labelFields: ['Leverantör'] },
      {...SALES_VAT, labelFields: ['Leverantör']},
      {...RETURNS_VAT, labelFields: ['Leverantör']},
    ],
};

export const SALES_PER_SUPPLIER_AND_PRODUCT = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-supplier-and-product`,
  reportName: 'SalesPerSupplierAndProduct',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerSupplierAndProduct"
    defaultMessage="Sales per supplier and product"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerSupplierAndProduct',
  fields:
    [
      PRODUCT_KATEGORI_FIELD,
      // TODO supplier employee,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const SALES_PER_PRODUCT = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-product`,
  reportName: 'SalesPerProduct',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerProduct"
    defaultMessage="Sales per product"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerProduct',
  fields:
    [
      FREE_TEXT_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const SALES_PER_PRODUCT_AND_EMPLOYEE = {
  urlPath: `${STANDARD_REPORT_URL}/sales-per-product-and-employee`,
  reportName: 'SalesPerProductAndEmployee',
  reportTitle: <FormattedMessage
    id="report.title.SalesPerProductAndEmployee"
    defaultMessage="Sales per product and employee"
  />,
  isSieEnabled: false,
  serverName: 'SalesPerProductAndEmployee',
  fields:
    [
      PRODUCT_FIELD,
      // TODO dropdown employee,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
  charts:
    [
      {...NUMBER_OF_SOLD_GOODS, labelFields:['Produkt','Anställd']},
      {...SALES_VAT, labelFields: ['Produkt','Anställd']},
      {...RETURNS_VAT, labelFields: ['Produkt','Anställd']},
    ],
};

export const EMPLOYEE_WORK_TIME_CORRECTED_LOGS = {
  urlPath: `${STANDARD_REPORT_URL}/employee-work-time-corrected-logs`,
  reportName: 'EmployeeWorkTimeCorrectedLogs',
  reportTitle: <FormattedMessage
    id="report.title.EmployeeWorkTimeCorrectedLogs"
    defaultMessage="Employee work time corrected logs"
  />,
  isSieEnabled: false,
  serverName: 'EmployeeWorkTimeCorrectedLogs',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: TODAY_AS_DATE },
      { ...DATE_TO_FIELD, initialValue: TODAY_AS_DATE },
    ],
};

export const INVENTORY_ITEM_STOCK_CHANGES_LIST = {
  urlPath: `${STANDARD_REPORT_URL}/inventory-item-stock-changes-list`,
  reportName: 'InventoryItemStockChangesList',
  reportTitle: <FormattedMessage
    id="report.title.InventoryItemStockChangesList"
    defaultMessage="Inventory item stock changes list"
  />,
  isSieEnabled: false,
  serverName: 'InventoryItemStockChangesList',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
    ],
};

export const GIFT_CARD_TRANSACTION_LOG = {
  urlPath: `${STANDARD_REPORT_URL}/gift-card-transaction-log`,
  reportName: 'GiftCardTransactionLog',
  reportTitle: <FormattedMessage
    id="report.title.GiftCardTransactionLog"
    defaultMessage="Gift card transaction log"
  />,
  isSieEnabled: false,
  serverName: 'GiftCardTransactionLog',
  fields:
    [
      GIFT_CARD_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
      { ...PURCHASE_REFILL_GIFTS_CARDS_FIELD, initialValue: true },
      { ...PAYMENT_BY_GIFT_CARD_FIELD, initialValue: true },
    ],
};

export const GIFT_CARD_BALANCE_CHANGE_LOG = {
  urlPath: `${STANDARD_REPORT_URL}/gift-card-balance-change-log`,
  reportName: 'GiftCardBalanceChangeLog',
  reportTitle: <FormattedMessage
    id="report.title.GiftCardBalanceChangeLog"
    defaultMessage="Gift card balance change log"
  />,
  isSieEnabled: false,
  serverName: 'GiftCardBalanceChangeLog',
  fields:
    [
      GIFT_CARD_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
      { ...DEPOSIT_FIELD, initialValue: true },
      { ...WITHDRAWAL_FIELD, initialValue: false },
    ],
};

export const GIFT_CARD_BALANCE_PER_DATE = {
  urlPath: `${STANDARD_REPORT_URL}/gift-card-balance-per-date`,
  reportName: 'GiftCardBalancePerDate',
  reportTitle: <FormattedMessage
    id="report.title.GiftCardBalancePerDate"
    defaultMessage="Gift card balance per date"
  />,
  isSieEnabled: false,
  serverName: 'GiftCardBalancePerDate',
  fields:
    [
      GIFT_CARD_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
    ],
};

export const DISCOUNT_PER_EMPLOYEE_REPORT = {
  urlPath: `${STANDARD_REPORT_URL}/discount-per-employee-report`,
  reportName: 'DiscountPerEmployeeReport',
  reportTitle: <FormattedMessage
    id="report.title.DiscountPerEmployeeReport"
    defaultMessage="Discount per employee report"
  />,
  isSieEnabled: false,
  serverName: 'DiscountPerEmployeeReport',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
  charts:
    [
      { ...NUMBER_OF_DISCOUNTS, labelFields: ['Anställd#', 'Anställd-namn'] },
      {...SUM, labelFields: ['Anställd#', 'Anställd-namn']},
    ],
};

export const DISCOUNT_PER_TYPE = {
  urlPath: `${STANDARD_REPORT_URL}/discount-per-type`,
  reportName: 'DiscountReport',
  reportTitle: <FormattedMessage
    id="report.title.DiscountReport"
    defaultMessage="Discount report per type"
  />,
  isSieEnabled: false,
  serverName: 'DiscountReportPerType',
  fields:
    [
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
  charts:
    [
      { ...NUMBER_OF_DISCOUNTS, labelFields: ['Rabatt typ'] },
      {...SUM, labelFields: ['Rabatt typ']},
    ]
};

export const INVALID_REGISTRATIONS_LOG = {
  urlPath: `${STANDARD_REPORT_URL}/invalid-registrations-log`,
  reportName: 'InvalidRegistrationsLog',
  reportTitle: <FormattedMessage
    id="report.title.InvalidRegistrationsLog"
    defaultMessage="Invalid registrations log"
  />,
  isSieEnabled: false,
  serverName: 'InvalidRegistrationsLog',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE = {
  urlPath: `${STANDARD_REPORT_URL}/invalid-registrations-log-per-employee`,
  reportName: 'InvalidRegistrationsByEmployee',
  reportTitle: <FormattedMessage
    id="report.title.InvalidRegistrationsByEmployee"
    defaultMessage="Invalid registrations per employee"
  />,
  isSieEnabled: false,
  serverName: 'InvalidRegistrationsByEmployee',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY = {
  urlPath: `${STANDARD_REPORT_URL}/invalid-registrations-log-per-employee-and-day`,
  reportName: 'InvalidRegistrationsByDayAndEmployee',
  reportTitle: <FormattedMessage
    id="report.title.InvalidRegistrationsByDayAndEmployee"
    defaultMessage="Invalid registrations per day and employee"
  />,
  isSieEnabled: false,
  serverName: 'InvalidRegistrationsPerDayAndEmployee',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const WASTE_REGISTRATIONS_LOG = {
  urlPath: `${STANDARD_REPORT_URL}/waste-registrations-log`,
  reportName: 'WasteRegistrationsLog',
  reportTitle: <FormattedMessage
    id="report.title.WasteRegistrationsLog"
    defaultMessage="Waste registrations log"
  />,
  isSieEnabled: false,
  serverName: 'WasteRegistrationsLog',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE = {
  urlPath: `${STANDARD_REPORT_URL}/waste-registrations-log-per-employee`,
  reportName: 'WasteRegistrationsByEmployee',
  reportTitle: <FormattedMessage
    id="report.title.WasteRegistrationsByEmployee"
    defaultMessage="Waste registrations log per employee"
  />,
  isSieEnabled: false,
  serverName: 'WasteRegistrationsByEmployee',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY = {
  urlPath: `${STANDARD_REPORT_URL}/waste-registrations-log-per-employee-and-day`,
  reportName: 'WasteRegistrationsByDayAndEmployee',
  reportTitle: <FormattedMessage
    id="report.title.WasteRegistrationsByDayAndEmployee"
    defaultMessage="Waste registrations log per day and employee"
  />,
  isSieEnabled: false,
  serverName: 'WasteRegistrationsPerDayAndEmployee',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...TIME_FROM_FIELD, initialValue: SIX_AM },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...TIME_TO_FIELD, initialValue: SIX_AM },
    ],
};

export const EMPLOYEE_LOGGED_IN_PER_DAY_LOG = {
  urlPath: `${STANDARD_REPORT_URL}/employee-logged-in-per-day-log`,
  reportName: 'EmployeeLoggedInPerDayLog',
  reportTitle: <FormattedMessage
    id="report.title.EmployeeLoggedInPerDayLog"
    defaultMessage="Employee logged in per day log"
  />,
  isSieEnabled: false,
  serverName: 'EmployeeLoggedInPerDayLog',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: TODAY_AS_DATE },
      { ...DATE_TO_FIELD, initialValue: TODAY_AS_DATE },
    ],
};

export const EMPLOYEE_LOGGED_IN_PER_MONTH_LOG = {
  urlPath: `${STANDARD_REPORT_URL}/employee-logged-in-per-month-log`,
  reportName: 'EmployeeLoggedInPerMonthLog',
  reportTitle: <FormattedMessage
    id="report.title.EmployeeLoggedInPerMonthLog"
    defaultMessage="Employee logged in per month log"
  />,
  isSieEnabled: false,
  serverName: 'EmployeeLoggedInPerMonthLog',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: TODAY_AS_DATE },
      { ...DATE_TO_FIELD, initialValue: TODAY_AS_DATE },
    ],
};

export const EMPLOYEE_LOGGED_IN_LOG = {
  urlPath: `${STANDARD_REPORT_URL}/employee-logged-in-log`,
  reportName: 'EmployeeLoggedInLog',
  reportTitle: <FormattedMessage
    id="report.title.EmployeeLoggedInLog"
    defaultMessage="Employee logged in log"
  />,
  isSieEnabled: false,
  serverName: 'EmployeeLoggedInLog',
  fields:
    [
      PERSONAL_NR_FIELD,
      NAME_FIELD,
      { ...DATE_FROM_FIELD, initialValue: TODAY_AS_DATE },
      { ...DATE_TO_FIELD, initialValue: TODAY_AS_DATE },
    ],
};

export const TRANSACTION_LIST = {
  urlPath: `${SIE4_REPORT_URL}/transaction-list`,
  reportName: 'TransactionList',
  reportTitle: <FormattedMessage
    id="report.title.TransactionList"
    defaultMessage="Transaction list"
  />,
  isSieEnabled: true,
  serverName: 'Sie4TransactionList',
  fields:
    [
      FREE_TEXT_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...INCLUDE_INVOICES_FIELD, initialValue: false },
    ],
};

export const TRANSACTION_LIST_SIE_DAY_LIST = {
  urlPath: `${SIE4_REPORT_URL}/transaction-sie-day-list`,
  reportName: 'TransactionsSieDayList',
  reportTitle: <FormattedMessage
    id="report.title.TransactionsSieDayList"
    defaultMessage="ToplistReport SIE day list"
  />,
  isSieEnabled: true,
  serverName: 'Sie4TopDayList',
  fields:
    [
      FREE_TEXT_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...INCLUDE_INVOICES_FIELD, initialValue: false },
    ],
};

export const TRANSACTION_LIST_SIE_Z_REPORT_LIST = {
  urlPath: `${SIE4_REPORT_URL}/sie-export`,
  reportName: 'TransactionsSieZReportList',
  reportTitle: <FormattedMessage
    id="report.title.TransactionsSieZReportList"
    defaultMessage="SIE-export"
  />,
  isSieEnabled: true,
  serverName: 'Sie4TopZReportList',
  fields:
    [
      FREE_TEXT_FIELD,
      { ...DATE_FROM_FIELD, initialValue: FIRST_DAY_OF_CURRENT_MONTH },
      { ...DATE_TO_FIELD, initialValue: LAST_DAY_OF_CURRENT_MONTH },
      { ...INCLUDE_INVOICES_FIELD, initialValue: false },
    ],
};

export const REPORTS_LIST = [
  EMPLOYEE_TIME_WORKED,
  PAYMENTS_PER_DAY,
  PAYOUT_PER_PRODUCT,
  PAYOUT_PER_CATEGORY,
  PAYMENTS_PER_DAY_AND_EMPLOYEE,
  PAYMENTS_TOTAL,
  CASH_GUARD_TRANSACTION_LOG,
  EHK_SALES_OVERVIEW,
  SALES_AND_PAYMENTS_PER_CATEGORY,
  SALES_PER_DATE,
  SALES_PER_CAMPAIGN,
  SALES_PER_CATEGORY,
  SALES_PER_CATEGORY_AND_EMPLOYEE,
  SALES_PER_CATEGORY_AND_CUSTOMER,
  SALES_PER_SUPPLIER,
  SALES_PER_SUPPLIER_AND_PRODUCT,
  SALES_PER_PRODUCT,
  SALES_PER_PRODUCT_AND_EMPLOYEE,
  EMPLOYEE_WORK_TIME_CORRECTED_LOGS,
  INVENTORY_ITEM_STOCK_CHANGES_LIST,
  GIFT_CARD_TRANSACTION_LOG,
  GIFT_CARD_BALANCE_CHANGE_LOG,
  GIFT_CARD_BALANCE_PER_DATE,
  DISCOUNT_PER_EMPLOYEE_REPORT,
  DISCOUNT_PER_TYPE,
  INVALID_REGISTRATIONS_LOG,
  INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE,
  INVALID_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY,
  WASTE_REGISTRATIONS_LOG,
  WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE,
  WASTE_REGISTRATIONS_LOG_PER_EMPLOYEE_AND_DAY,
  EMPLOYEE_LOGGED_IN_PER_DAY_LOG,
  EMPLOYEE_LOGGED_IN_PER_MONTH_LOG,
  EMPLOYEE_LOGGED_IN_LOG,
  TRANSACTION_LIST,
  TRANSACTION_LIST_SIE_DAY_LIST,
  TRANSACTION_LIST_SIE_Z_REPORT_LIST,
];

export const REPORTS_NAMES = {
  SalesPerCategory: SALES_PER_CATEGORY,
  SalesPerSupplier: SALES_PER_SUPPLIER,
  SalesPerProductAndEmployee: SALES_PER_PRODUCT_AND_EMPLOYEE,
  SalesPerDate: SALES_PER_DATE,
  SalesAndPaymentsPerCategory: SALES_AND_PAYMENTS_PER_CATEGORY,
  SalesPerCategoryAndEmployee: SALES_PER_CATEGORY_AND_EMPLOYEE,
  DiscountReport: DISCOUNT_PER_TYPE,
  DiscountPerEmployeeReport: DISCOUNT_PER_EMPLOYEE_REPORT,
};